import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useLogout } from './Auth.hooks';

export function Logout() {
	const navigate = useNavigate();
	const isLoading = useLogout();
	useEffect(() => {
		if (!isLoading) {
			navigate({ to: '/' });
		}
	}, [isLoading]);
	return <div>Loading</div>;
}
